/* eslint-disable react/no-unescaped-entities */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ContactFooter from './ContactFooter';
import formatAddressForDisplay from './formatAddressForDisplay';

class UnavailabilityModal extends Component {
  sendEventToAnalytics = () => {
    const thdAnalyticsEvent = {
      category: {
        primaryCategory: 'overlay',
      },
      eventInfo: {
        eventName: 'mandi unavailable modal',
      },
    };
    // eslint-disable-next-line no-undef
    if (_T.sendEventDataToAnalytics) {
      // eslint-disable-next-line no-undef
      _T.sendEventDataToAnalytics(thdAnalyticsEvent);
    }
  }
  render() {
    this.sendEventToAnalytics();
    return (
      <div className="covered-step">
        <div className="subject">
          Service providers are unavailable in your area at this time.
        </div>
        <div className="description">
          <strong>The good news? </strong>{' '}
          You can still shop online for top quality window treatments and
          they'll ship free right to your door.
          Nervous about doing it yourself?
          Don't worry, we've helped millions of customers through the process and
          guarantee the perfect fit.
        </div>
        <div><strong>Or call a Design Consultant at 866-585-0066</strong></div>
        <div className="results">
          <strong>Showing Results For:</strong>
          {formatAddressForDisplay(this.props.address)}
        </div>
        <div className="footer">
          <ContactFooter />
        </div>
      </div>
    );
  }
}
UnavailabilityModal.propTypes = {
  address: PropTypes.shape({
    line1: PropTypes.string,
    line2: PropTypes.string,
    city: PropTypes.string,
    state: PropTypes.string,
    zipCode: PropTypes.string,
  }).isRequired,
};

export default UnavailabilityModal;
